import React from "react"
import { ApolloProvider } from "@apollo/client"
import { client } from "./client"
import Wrapper from "./wrapper"
export const wrapRootElement = ({ element }) => {
  return (
    <ApolloProvider client={client}>
      <Wrapper>
        {element}
      </Wrapper>
    </ApolloProvider>
  )
}
